<template>
<h1 v-if='numOfPage > 1'>
	<button v-on:click='decrement' v-bind:disabled='currentPage <= 1' class='page-button--left'>Prev</button>
	<span v-if='numOfPage'>{{ currentPage}} / {{ numOfPage }}</span>
	<button v-on:click='increment' v-bind:disabled='currentPage >= numOfPage' class='page-button--right'>Next</button>
</h1>
</template>

<script>
export default {
	name: "Paginate",
	props: ['currentPage', 'numOfPage'],
	methods: {
		scrollTop() {
			window.scrollTo(0, 0)
		},
		decrement() {
			this.$emit('decrementPage')
			this.scrollTop()
		},
		increment() {
			this.$emit('incrementPage')
			this.scrollTop()
		}
	}
}
</script>

<style lang='stylus'>
.page-button
	&--left
		margin-right: 1em
	&--right
		margin-left: 1em
</style>
